// extracted by mini-css-extract-plugin
module.exports = {"navigation":"Navigation_navigation__1EgxP","brandName":"Navigation_brandName__16Dmg"};